module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "acknow"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "fronthead"
  }, [_vm._v("A"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("CKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "html/docimages/image1.jpg",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }, [_vm._v("I would like to thank my husband Dave for his love and constant support.")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }, [_vm._v("Also my precious children and grandchildren.")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }, [_vm._v("My beloved mother, Jeannie. Always with me.")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }, [_vm._v("Shirley, Dave and family for believing in me.")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }, [_vm._v("My dear friends Maimie, Sonja, Mona, Alison, Kay, Donald, Malcolm, Harry and the Writers Group.")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }, [_vm._v("Maurice Fleming and John Beaton, who set the word in motion.")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }, [_vm._v("Tom, Catherine and Seán.")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }, [_vm._v("And to those too numerous to mention—thank you all, from my heart.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-082fe417","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/007_acknow.vue
// module id = 78
// module chunks = 0